<template>
    <div class="container-fluid hero-section" v-if="pantalla"
        style="background-image: url('https://beauvoyage.net/luna-de-mil-destinos-españa.jpg'); margin-top: 100px; margin-bottom: 100px;">
        <div class="row justify-content-center">
            <div class="col-md-5 col-lg-4">
                <div class="card-overlay text-center">
                    <h2 class="display-6 fw-bold mb-3" style="color: #343a40;">Luna de Miel</h2>
                    <p class="lead mb-4">Una experiencia inolvidable para celebrar el amor y comenzar una nueva etapa
                        juntos.</p>

                    <ul class="list-unstyled text-center mb-4">
                        <li class="mb-2"><i class="bi bi-heart-fill" style="color: #f7941d;"></i>Estancia romántica en
                            un resort frente al mar.</li>
                        <li class="mb-2"><i class="bi bi-sunset" style="color: #f7941d;"></i>Cena privada al atardecer
                            con vista al océano.</li>
                        <li class="mb-2"><i class="bi bi-airplane-fill" style="color: #f7941d;"></i>Viaje a un destino
                            exótico lleno de encanto.</li>
                    </ul>


                    <a href="#element1" class="btn btn-primary btn-lg text-light">Ver
                        más</a>
                </div>
            </div>
        </div>
    </div>

    <div class="container my-5" id="element1" v-if="pantalla">
        <h2 class="text-center fw-normal mb-5">¿Cómo funciona?</h2>
    </div>

    <div class="container steps-container mb-5" v-if="pantalla">
        <div class="row">
            <div class="col-6 col-md-3 step-item mb-4 mb-md-0">
                <div class="step-number">1</div>

                <p class="fw-bold">Registra y crear tu mesa</p>
                <img src="https://beauvoyage.net/Captura de pantalla 2025-10-16 142856.png" class="img-fluid mb-2"
                    alt="">
            </div>

            <div class="col-6 col-md-3 step-item mb-4 mb-md-0">
                <div class="step-number">2</div>
                <p class="fw-bold">Selecciona tu viaje</p>
                <img src="https://beauvoyage.net/fee2d3d9f9b224f823789fdcf1ca866f64788953.png" class="img-fluid mb-2"
                    alt="Seleccionar viaje">


            </div>

            <div class="col-6 col-md-3 step-item">
                <div class="step-number">3</div>
                <p class="fw-bold">Administra las aportaciones</p>
                <img src="https://beauvoyage.net/1e724f4d8f82f32ca58bdf1691fda37ddc1fd7ed.png" class="img-fluid mb-2"
                    alt="Administrar aportaciones">


            </div>

            <div class="col-6 col-md-3 step-item">
                <div class="step-number">4</div>
                <p class="fw-bold">Comparte tu Evento</p>
                <img src="https://beauvoyage.net/582c53ee8b5826031369bdef1b46b07969d812a3.png" class="img-fluid mb-2"
                    alt="Compartir evento">


            </div>
        </div>
        <center>
            <a href="#element1" class="btn btn-primary btn-lg text-light mt-3" @click="togglePantalla">Siguiente</a>
        </center>

    </div>
    <div class="container" style="margin-top: 200px; margin-bottom: 100px;" v-if="pantalla2">
        <h2 class="mb-4 text-center">Buscar Mesa de Regalo</h2>

        <!-- Input y botón -->
        <div class="input-group mb-5 justify-content-center">
            <input type="number" class="form-control" placeholder="Ingresa el ID de la mesa" v-model="mesaId" />
            <button class="btn btn-primary text-light" @click="buscarMesa">Buscar</button>
        </div>
        <center>
            <a :href="`https://wa.me/525545401703?text=${encodeURIComponent('Hola, me interesa crear mi mesa de regalos')}`"
                target="_blank" class="btn btn-success btn-lg my-3" style="gap: 8px;">
                <i class="fab fa-whatsapp"></i> Quiero crear mi mesa de regalos
            </a>
        </center>


        <!-- Spinner -->
        <div v-if="loading" class="text-center my-3">
            <div class="spinner-border text-primary" role="status"></div>
        </div>

        <!-- Error -->
        <div v-if="error" class="alert alert-danger text-center">{{ error }}</div>

        <!-- Card de la mesa -->
        <div v-if="mesa" class="card shadow-lg mx-auto" style="max-width: 900px;">
            <div class="row g-0">
                <!-- Imagen del evento -->
                <div class="col-md-4">
                    <img :src="`https://beauvoyage.net/storage/${mesa.imgEvent}`" class="img-fluid rounded-start"
                        alt="Imagen del evento" />
                </div>

                <div class="col-md-8">
                    <div class="card-body">
                        <h4 class="card-title">{{ mesa.nombre }} {{ mesa.aPaterno }} {{ mesa.aMaterno }}</h4>
                        <p class="text-muted mb-2"><strong>Tipo de Evento:</strong> {{ mesa.tipoEvento }}</p>
                        <p class="text-muted mb-2"><strong>Administrador:</strong> {{ mesa.tipoAdmin === "0" ? 'Normal'
                            : 'Especial' }}</p>
                        <p class="text-muted mb-2"><strong>Fecha del Evento:</strong> {{ formatDate(mesa.fEvento) }}</p>
                        <p class="text-muted mb-2"><strong>Correo:</strong> {{ mesa.correo }}</p>
                        <p class="text-muted mb-2"><strong>Móvil:</strong> {{ mesa.movil }}</p>

                        <hr />
                        <div class="my-4" v-if="mesa.viaje.tarifa">
                            <h6>Progreso de la mesa de regalo:</h6>
                            <div class="progress" style="height: 25px;">
                                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                                    :style="{ width: progreso + '%' }" :aria-valuenow="progreso" aria-valuemin="0"
                                    aria-valuemax="100">
                                    {{ montoAcumulado }} / {{ mesa.viaje.tarifa.toLocaleString() }} MXN
                                </div>
                            </div>
                        </div>
                        <!-- Card del viaje -->
                        <div class="card bg-light shadow-sm">
                            <div class="row g-0">
                                <div class="col-md-4">
                                    <img :src="`https://beauvoyage.net/${mesa.viaje.img}`"
                                        class="img-fluid rounded-start" alt="Imagen del viaje" />
                                </div>
                                <div class="col-md-8">
                                    <div class="card-body">
                                        <h5 class="card-title">{{ mesa.viaje.nombre }}</h5>
                                        <p class="card-text mb-1"><strong>Paises:</strong> {{ mesa.viaje.paises }}</p>
                                        <p class="card-text mb-1"><strong>Duración:</strong> {{ mesa.viaje.duracion }}
                                        </p>
                                        <p class="card-text mb-1"><strong>Tarifa:</strong> ${{
                                            mesa.viaje.tarifa.toLocaleString() }} MXN</p>
                                        <p class="card-text mb-1"><strong>Vuelo:</strong> {{ mesa.viaje.vuelo }}</p>

                                        <center>
                                            <a :href="getDownloadUrl(mesa.viaje.pdf)"
                                                class="btn btn-sm btn-primary text-light">
                                                <i class="fa-solid fa-file-pdf"></i>
                                                Descargar PDF
                                            </a>
                                            <a :href="`https://wa.me/525545401703?text=${encodeURIComponent('Hola, Me gustaría contribuir a la mesa de regalos de ' + mesa.nombre + ' ' + mesa.aPaterno + ' ' + mesa.aMaterno + ' con el ID: %' + mesa.id + '%')}`"
                                                target="_blank" class="btn btn-success btn-sm my-3 ml-1"
                                                style="gap: 8px;">
                                                <i class="fab fa-whatsapp"></i> Me gustaría contribuir
                                            </a>
                                            <div v-if="mesa" class="mt-1 text-center">
                                                <button class="btn btn-secondary btn-sm my-3 text-bg-light"
                                                    @click="compartirMesa">
                                                    <i class="fa-solid fa-link"></i>
                                                    Compartir esta mesa
                                                </button>
                                            </div>
                                        </center>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fin card viaje -->

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            mesaId: "",
            mesa: null,
            loading: false,
            error: "",
            pantalla: true,
            pantalla2: false,
        };
    },
    async mounted() {
        // Capturamos el query param "id"
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");

        if (id) {
            this.mesaId = id;
            await this.buscarMesa();
        }
    },
    methods: {
        async buscarMesa() {
            if (!this.mesaId) {
                this.error = "Por favor ingresa un ID válido";
                this.mesa = null;
                return;
            }

            this.loading = true;
            this.error = "";
            this.mesa = null;

            try {
                const response = await axios.get(`https://beauvoyage.net/api/VerMesa/${this.mesaId}`);
                this.mesa = response.data;
            } catch (err) {
                this.error = "No se encontró la mesa con ese ID";
            } finally {
                this.loading = false;
            }
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString("es-MX", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        },
        getDownloadUrl(path) {
            if (!path) return "#"; // evita error si aún no existe
            const filename = path.split("/").pop();
            return `https://beauvoyage.net/api/descargarPdf/${filename}`;
        },
        compartirMesa() {
            if (!this.mesa) return;

            const enlace = `https://beauvoyage.net/MesaRegalos?id=${this.mesa.id}`;

            // Copiar al portapapeles
            navigator.clipboard.writeText(enlace)
                .then(() => {
                    alert(`¡Enlace copiado! ${enlace}`);
                })
                .catch(() => {
                    alert("No se pudo copiar el enlace");
                });

            // O abrir en una nueva pestaña (opcional)
            // window.open(enlace, "_blank");
        },
        togglePantalla() {
            this.pantalla = !this.pantalla;
            this.pantalla2 = !this.pantalla2;
        },
    },
    computed: {
        montoAcumulado() {
            // Si acumulado es null, lo tratamos como 0
            return this.mesa.acumulado ? this.mesa.acumulado : 0;
        },
        progreso() {
            if (!this.mesa || !this.mesa.viaje.tarifa) return 0;
            // porcentaje = (acumulado / tarifa) * 100
            return Math.min((this.montoAcumulado / this.mesa.viaje.tarifa) * 100, 100).toFixed(2);
        },
    },
};
</script>

<style>
.card {
    border-radius: 15px;
}

.card img {
    object-fit: cover;
    height: 100%;
}

.card-body h4,
.card-body h5 {
    color: #333;
}

.hero-section {
    position: relative;
    background-image: url('https://beauvoyage.net/e108f0198e0fd3bc301bf7e1dbb177605d9851c1.png');
    /* Reemplaza con una imagen de fondo si quieres el efecto exacto */
    background-size: cover;
    background-position: center;
    padding: 5rem 0;
    /* Espacio alrededor del contenido */
    min-height: 400px;
}

.card-overlay {
    background-color: rgba(255, 255, 255, 0.95);
    /* Fondo blanco semitransparente para la tarjeta */
    border-radius: 0.5rem;
    padding: 2rem;
    max-width: 450px;
    /* Ajusta el ancho de la tarjeta */
    margin: 0 auto;
    /* Centrar la tarjeta */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Estilos para el timeline/pasos */
.step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.step-number {
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    background-color: #f7941d;
    /* Naranja similar al de la imagen */
    color: white;
    font-weight: bold;
    margin-bottom: 1rem;
    z-index: 10;
    /* Asegura que el círculo esté sobre la línea */
}

.step-icon-circle {
    width: 70px;
    height: 70px;
    line-height: 70px;
    border-radius: 50%;
    border: 2px solid #f7941d;
    background-color: #fff;
    margin-top: 1rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.step-icon-circle .checkmark {
    font-size: 2.5rem;
    color: #f7941d;
}

/* Línea divisoria para el timeline (un poco más avanzado) */
.steps-container {
    position: relative;
    padding-top: 2rem;
    padding-bottom: 2rem;
}

.steps-container::before {
    content: '';
    position: absolute;
    top: calc(2rem + 20px);
    /* Ajusta para que quede a la altura del número */
    left: 10%;
    /* Comienzo de la línea */
    right: 10%;
    /* Final de la línea */
    height: 2px;
    background-color: #ccc;
    z-index: 5;
    /* Solo visible en pantallas grandes (desktop) */
    display: none;
}

@media (min-width: 768px) {
    .steps-container::before {
        display: block;
        /* Muestra la línea en desktop */
    }
}
</style>
